"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultConfigs = exports.TRACKER_NAME = exports.GLOBAL_SNOWPLOW_NAME = exports.APP_VERSION = void 0;
exports.getEventContext = getEventContext;
exports.hasActivityTrackingEnabled = hasActivityTrackingEnabled;
exports.videoTrackingPlaybackRateChanged = videoTrackingPlaybackRateChanged;
exports.videoTrackingStart = videoTrackingStart;
exports.videoTrackingStop = videoTrackingStop;
exports.videoTrackingTimeUpdated = videoTrackingTimeUpdated;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// Video Activity Tracking Utils
function isValidNumber(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
}
var GLOBAL_SNOWPLOW_NAME = exports.GLOBAL_SNOWPLOW_NAME = 'hudlSnowplowVideoActivityTracker';
var TRACKER_NAME = exports.TRACKER_NAME = 'hudlVideoActivityTracker';
// Note this matches the `hudl-user-tracking` package and is updated automatically on commit
var APP_VERSION = exports.APP_VERSION = '3.3.0';
var defaultConfigs = exports.defaultConfigs = {
  TEST: {
    appId: 'hudl',
    collectorEndpoint: 'jnl7d8fsqlfo91xd.thorhudl.com',
    cookieDomain: '.thorhudl.com',
    discoverRootDomain: false,
    encodeBase64: true,
    forceSecureTracker: true,
    platform: 'web',
    post: true,
    stateStorageStrategy: 'localStorage',
    userFingerprint: true,
    contexts: {
      webPage: true,
      gaCookies: false,
      geolocation: false,
      performanceTiming: false
    }
  },
  PROD: {
    appId: 'hudl',
    collectorEndpoint: 'jnl7d8fsqlfo91xd.hudl.com',
    cookieDomain: '.hudl.com',
    discoverRootDomain: false,
    encodeBase64: true,
    forceSecureTracker: true,
    platform: 'web',
    post: true,
    stateStorageStrategy: 'localStorage',
    userFingerprint: true,
    contexts: {
      webPage: true,
      gaCookies: false,
      geolocation: false,
      performanceTiming: false
    }
  }
};
function getEventContext(config) {
  var playingIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (!config || !config.activityTrackerOptions || playingIndex < 0) {
    return [];
  }
  var context = _toConsumableArray(config.activityTrackerOptions.context);
  var playableContext = config.activityTrackerOptions.playableContext || [];
  if (playableContext.length > 0 && playableContext[playingIndex]) {
    context.push(playableContext[playingIndex]);
  }
  return context;
}
function hasActivityTrackingEnabled(_ref) {
  var activityTrackerOptions = _ref.activityTrackerOptions;
  return activityTrackerOptions && activityTrackerOptions.config && activityTrackerOptions.config.isEnabled && activityTrackerOptions.config.trackerConfigKey && !!activityTrackerOptions.context;
}

// Video player event callbacks
// NOTE: these expect the context of the VideoPlayer to be bound
function videoTrackingStart() {
  if (!this.activityTracker) {
    return;
  }

  // Set the relevant event context based on the current playing index
  var context = getEventContext(this.config, this.playingIndex);
  this.activityTracker.setContext(context);
  this.activityTracker.start();
}
function videoTrackingStop() {
  if (!this.activityTracker) {
    return;
  }
  this.activityTracker.stop();
}
function videoTrackingPlaybackRateChanged() {
  if (!this.activityTracker || !isValidNumber(this.playbackRate)) {
    return;
  }
  this.activityTracker.updatePlaybackRate(this.playbackRate);
}
function videoTrackingTimeUpdated() {
  if (!this.activityTracker || !isValidNumber(this.currentTime)) {
    return;
  }
  this.activityTracker.updateCurrentPlaybackTimeMs(Math.floor(this.currentTime * 1000));
}